import { useContext, useState } from 'react';
import Cards from '../../../assets/images/carde.png'

// @styles 
import './styles.scss'
import Context from 'context/appContext';
import { useEffect } from 'react';
import { setFieldsValue } from 'utils/utils';

export default function CardsAdditional({ info: data, openNotification, serviceCalculator }) {
    const [defaultClass, setDefaultClass] = useState('active-btn-right');
    const keyAdditionals = 'aditionals';
    const { dataForm: { formResponses }, isActiveAditionals, setIsActiveAditionals } = useContext(Context)
    useEffect(() => {

        const field = formResponses.find(x => x.key === keyAdditionals);
        const active = field && field.active
        const obj = field && field.activeAux
        // active && setIsActiveAditionals(active);
        // obj && setIsClassAux(obj);
    }, []);


    const setAdditionals = (isActiveAditionals) => {
        const indexField = formResponses.findIndex(x => x.key === keyAdditionals);
        const obj = { key: keyAdditionals, active: isActiveAditionals };
        indexField !== -1 ? formResponses[indexField] = obj : formResponses.push(obj);
    }

    useEffect(() => {
        const obj = { key: keyAdditionals, active: isActiveAditionals };
        const indexField = formResponses.findIndex(x => x.key === keyAdditionals);
        indexField !== -1 ? formResponses[indexField] = obj : formResponses.push(obj);
    }, [isActiveAditionals]);

    const onClick = async (index, active) => {
        const obj = { ...isActiveAditionals, [index]: active };
        setAdditionals(obj);
        setFieldsValue(index, active, null, formResponses);
        setIsActiveAditionals(obj);
        setDefaultClass('active-btn-right');
        await serviceCalculator();
        openNotification(active);
    };
    return (<>
        <div className='coverages-economy additional-card'>
            <div className='coverages-economy__content'>
                {data && data.components.map((card) => {
                    const index = card && card.key;
                    return card && card.type === 'radio' ? <div className='coverages-economy__content-additionalcards'>
                        <div className={`coverages-economy__content-additionalcards__item ${isActiveAditionals[index] ? 'active-card' : ''}`}>
                            <img className='coverages-economy__content-additionalcards__item-img' src={card && card.properties && card.properties.img ? card.properties.img : Cards} alt={card?.label} />
                            <div className={`coverages-economy__content-additionalcards__item-text ${card.values[0].label == 'Incluida' ? 'padding-top' : ''}`}>
                                <strong>{card && card.label}</strong>
                                <p>{card && card.description}</p>
                            </div>
                            <div className='coverages-economy__content-additionalcards__item-actions'>
                                {card && card.values && card.type === 'radio' && card.values.length === 1 ? (
                                    <div className='coverages-economy__content-additionalcards__item-actions-included'>
                                        {card.values[0] && card.values[0].label ? card.values[0].label.toUpperCase() : 'INCLUIDA'}
                                    </div>) :
                                    <div className='smallswitch__container' id={index}>
                                        <div className='smallswitch__container__buttons' id={index}>
                                            <button className={`smallswitch__container__buttons-btn ${!isActiveAditionals[index] ? 'active-btn-left' : ''}`}
                                                disabled={!isActiveAditionals[index]}
                                                onClick={() => onClick(index, false)}>
                                                <span>No</span>
                                            </button>
                                            <button className={`smallswitch__container__buttons-btn ${isActiveAditionals[index] && defaultClass}`}
                                                disabled={isActiveAditionals[index]}
                                                onClick={() => onClick(index, true)}>
                                                <span>Si</span>
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div> :
                        <div className='coverages-economy__content-additionaltext'>
                            <div>
                                <td dangerouslySetInnerHTML={{ __html: card && card.html ? card.html : "" }} />
                            </div>
                        </div>
                })}
            </div>
        </div>
    </>
    )
}